export default __webpack_public_path__ + "static/media/Using-the-Alumni-Search-Tool.a51e0431.pdf";